import { Checkbox } from "../utils/local-antd";
import type {
  CheckboxOptionType,
  GetProp,
  CheckboxGroupProps,
} from "../utils/local-antd";

import React, { Fragment } from "react";
import styled from "styled-components";

import { Spacing } from "../theme/Spacing";
import { FontSize, Text } from "./Text";
import { TextWithTruncated } from "./TextWithTruncated";

const StyledCheckbox = styled(Checkbox.Group)<StyledAtiraBoxProps>`
  display: flex;
  flex-wrap: wrap;
  column-gap: ${({ columnGap }) => columnGap || Spacing.xxl};

  .ant-checkbox .ant-checkbox-inner {
    width: 1.5rem;
    height: 1.5rem;
  }

  .ant-checkbox-checked .ant-checkbox-inner {
    width: 1.5rem;
    height: 1.5rem;
  }

  .ant-checkbox-wrapper {
    white-space: nowrap;
  }

  .ant-checkbox-disabled .ant-checkbox-inner {
    background-color: ${({ theme }) => theme.gray};
  }

  .ant-checkbox + span {
    font-size: ${({ fontSize }) => fontSize || FontSize.m};
    width: 5rem;
  }

  .ant-checkbox-checked .ant-checkbox-inner::after {
    transform: rotate(45deg) scale(1) translate(-50%, -70%);
  }

  .ant-checkbox-checked.ant-checkbox-disabled .ant-checkbox-inner {
    background-color: ${({ theme }) => theme.lightMain} !important;
    opacity: 0.7;
  }

  .ant-checkbox-checked.ant-checkbox-disabled .ant-checkbox-inner::after {
    border-inline-end: 2px solid ${({ theme }) => theme.white};
    border-bottom: 2px solid ${({ theme }) => theme.white};
  }
`;

type AtiraCheckBoxProps = {
  options: CheckboxOptionType[];
  value: string[];
  onChange: GetProp<typeof Checkbox.Group, "onChange">;
  style?: React.CSSProperties;
  fontSize?: string;
  columnGap?: string;
  disabled?: boolean;
  truncate?: boolean;
  valid?: boolean;
  errorMessage?: string;
} & CheckboxGroupProps;

type StyledAtiraBoxProps = {
  fontSize?: string;
  columnGap?: string;
  truncate?: boolean;
};

export const AtiraCheckBoxGroup: React.FC<AtiraCheckBoxProps> = ({
  truncate = true,
  ...props
}) => {
  const renderOptions = props.options.map((option) => ({
    ...option,
    label: truncate ? (
      <TextWithTruncated length={20}>
        {option.label as string}
      </TextWithTruncated>
    ) : (
      <Text> {option.label as string}</Text>
    ),
  }));

  return (
    <Fragment>
      <StyledCheckbox
        {...props}
        options={renderOptions}
        disabled={props.disabled}
      />
      {props.errorMessage ? (
        <Text color="danger">{props.errorMessage}</Text>
      ) : null}
    </Fragment>
  );
};
